<template>

  <div class="page">
    <div class="main">
      <!-- 頁面抬頭-->
      <section class="title-cover">
        <!-- 頁面標題-->
        <picture class="title-img"> <img src="../assets/awardPH/img/title.png"></picture>
      </section>
      <section class="awards awards-1st">
        <picture class="title-img"><img src="../assets/awardPH/img/no1.png"></picture>
        <ul class="awards-list">
          <li> <span class="name">Mr.Chen</span><span class="number">*******413</span></li>
        </ul>
        <picture class="awards-img"><img src="../assets/awardPH/img/no1-CAR.png"><img style="margin: -5% auto -6%;z-index: -1;"
            src="../assets/awardPH/img/bg-fifa.png"></picture>
      </section>
      <!-- 影片區-->
      <section class="video-cover">
        <picture class="title-img"><img src="../assets/awardPH/img/video-title.png"></picture>
        <div class="video-box"><iframe id="odysee-iframe" width="560" height="315"
          src="https://odysee.com/$/embed/特斯拉英文:6?r=wSexF3ohosVzk5VPEFEoJRbYmzEojK5n" allowfullscreen></iframe></div>
      </section>
      <section class="awards-cover">
        <!-- 2等獎-->
        <section class="awards awards-2st">
          <picture class="title-img"><img src="../assets/awardPH/img/no2.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Lai</span><span class="number">*****542</span></li>
            <li> <span class="name">Chan</span><span class="number">*****367</span></li>
            <li> <span class="name">Bong</span><span class="number">*****495</span></li>
          </ul>
        </section>
        <!-- 3等獎-->
        <section class="awards awards-3st">
          <picture class="title-img"><img src="../assets/awardPH/img/no3.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Yeo</span><span class="number">*****954</span></li>
            <li> <span class="name">Yap</span><span class="number">*****990</span></li>
            <li> <span class="name">Tan</span><span class="number">*****592</span></li>
            <li> <span class="name">Goh</span><span class="number">*****857</span></li>
            <li> <span class="name">Lim</span><span class="number">*****164</span></li>
            <li> <span class="name">Wong</span><span class="number">*****260</span></li>
          </ul>
        </section>
        <!-- 4等獎-->
        <section class="awards awards-4st">
          <picture class="title-img"><img src="../assets/awardPH/img/no4.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Sia</span><span class="number">*****485</span></li>
            <li> <span class="name">Lee</span><span class="number">*****016</span></li>
            <li> <span class="name">Ong</span><span class="number">*****367</span></li>
            <li> <span class="name">Gan</span><span class="number">*****691</span></li>
            <li> <span class="name">Chai</span><span class="number">*****522</span></li>
            <li> <span class="name">Neo</span><span class="number">*****486</span></li>
            <li> <span class="name">Fong</span><span class="number">*****943</span></li>
            <li> <span class="name">Pang</span><span class="number">*****130</span></li>
          </ul>
        </section>
        <!-- 5等獎-->
        <section class="awards awards-5st">
          <picture class="title-img"><img src="../assets/awardPH/img/no5.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Sim</span><span class="number">*****451</span></li>
            <li> <span class="name">Chong</span><span class="number">*****376</span></li>
            <li> <span class="name">Tai</span><span class="number">*****257</span></li>
            <li> <span class="name">Heng</span><span class="number">*****001</span></li>
            <li> <span class="name">Choo</span><span class="number">*****510</span></li>
            <li> <span class="name">Kuah</span><span class="number">*****318</span></li>
            <li> <span class="name">Ng</span><span class="number">*****894</span></li>
            <li> <span class="name">Kee</span><span class="number">*****468</span></li>
          </ul>
        </section>
      </section>
      <!-- 廠商-->
      <ul class="manufacturers-list">
        <li><img src="../assets/awardPH/img/logo-OB.png"></li>
        <li><img src="../assets/awardPH/img/logo-BWIN.png"></li>
        <li><img src="../assets/awardPH/img/logo-DBG.png"></li>
        <li><img src="../assets/awardPH/img/logo-QT.png"></li>
        <li><img src="../assets/awardPH/img/logo-GR.png"></li>
        <li><img src="../assets/awardPH/img/logo-BNG.png"></li>
        <li><img src="../assets/awardPH/img/logo-SA.png"></li>
      </ul>
    </div>
    <article class="btn-box"> <a class="btn btn-goHome" a href="https://www.ofa168.net"><img
          src="../assets/awardPH/img/icon-goHome.svg"></a></article>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },
}
</script>


<style scoped>
@import '../assets/awardPH/css/style.css';
</style>



// WEBPACK FOOTER //
// src/components/award168.vue